import 'babel-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router';
import { store } from './store/store';
import { LinkedinInsightTag } from './assets/env';

Vue.config.productionTip = false;

LinkedinInsightTag();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  data: {
    from: [],
  },
  components: { App },
  template: '<App/>',
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;

  const regEx = /\/news/;
  const fromPath = from.path;

  if (!fromPath.match(regEx)) {
    store.commit('updateBackTo', from.path);
  }

  // This code block adds relevant meta tags from the router object: https://alligator.io/vuejs/vue-router-modify-head/
  const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
  if (!nearestWithMeta) return next();
  nearestWithMeta.meta.metaTags.map((tagDef) => {
    const tag = document.createElement('meta');
    Object.keys(tagDef).forEach((key) => {
      tag.setAttribute(key, tagDef[key]);
    });
    tag.setAttribute('data-vue-router-controlled', '');
    return tag;
  })
    .forEach(tag => document.head.appendChild(tag));
  next();
  return true;
});



// WEBPACK FOOTER //
// ./src/main.js